/**
 * Fetch Notifications UseCase
 * Flutter source: lib/data/data_sources/messages_data_source.dart:7-44
 *
 * Fetches a paginated page of notifications for the given owner. The owner is
 * resolved by the caller (the hook passes `currentUser.firebaseId`); this use
 * case does not read auth. Defaults the page limit to
 * `NOTIFICATIONS_LIST_PAGINATION` (Flutter `notificationsListPagination = 4`,
 * lib/domain/constants/app_constants.dart:7).
 */
import { NotificationsService } from '@/domain/services/notifications/notificationsService';
import type { AppNotificationEntity } from '@/domain/entities/notification/appNotificationEntity';
import type { PageCursor } from '@/data/types/json';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';

export class FetchNotificationsUseCase {
  private notificationsService: NotificationsService;

  constructor(notificationsService: NotificationsService = NotificationsService.getInstance()) {
    this.notificationsService = notificationsService;
  }

  async execute(
    owner: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.NOTIFICATIONS_LIST_PAGINATION,
  ): Promise<{ notifications: AppNotificationEntity[]; hasMore: boolean; cursor?: PageCursor }> {
    return this.notificationsService.fetchNotifications(owner, cursor, limit);
  }
}
